import { getLocalUser } from './authHelpers';

interface RoleFilterInfo {
  clientId: string;
  userId: string;
  isAdmin: boolean;
}

export function getRoleFilterInfo(): RoleFilterInfo | null {
  const localUser = getLocalUser();
  if (!localUser?.client_id) return null;

  return {
    clientId: localUser.client_id,
    userId: localUser.email,
    isAdmin: (localUser.role || '').toLowerCase() === 'admin',
  };
}

export function buildSupabaseFilters(): Array<{ column: string; operator: string; value: string }> {
  const info = getRoleFilterInfo();
  if (!info) return [];

  const filters: Array<{ column: string; operator: string; value: string }> = [
    { column: 'client_id', operator: 'eq', value: info.clientId },
  ];

  if (!info.isAdmin) {
    filters.push({ column: 'user_id', operator: 'eq', value: info.userId });
  }

  return filters;
}
